import React, { useEffect, useState } from 'react'
import {
  Form,
  Input,
  Button,
  Card,
  Row,
  Col,
  Space,
  Progress,
  Checkbox,
  Upload,
  message,
  Modal, Select, Alert, InputNumber
} from 'antd'
import { UploadOutlined, KeyOutlined } from '@ant-design/icons'
import minijust_logo from '../../assets/img/minijust_logo.png'
import { PHONE_PATTERN } from '../../constants/general'
import InstitutionUserService from '../../services/InstitutionUserService'
import { useParams, useLocation, useNavigate } from 'react-router-dom'
import moment from 'moment'
import { type UploadChangeParam } from 'antd/es/upload'
import { v4 as uuidv4 } from 'uuid'

const BaillifRequestingBidSecurityFees: React.FC = () => {
  const [form] = Form.useForm()
  const { Option } = Select
  const navigate = useNavigate()
  const [currentStep, setCurrentStep] = useState(1)
  const [fullName, setBidderFullName] = useState('')
  const [phone_number, setPhoneNumber] = useState('')
  const [bailiffEmail, setBailiffEmail] = useState('')
  const [payment_date, setPaymentDate] = useState('')
  const [loadingRefund, setLoadingRefund] = useState(false)
  const [declarationChecked, setDeclarationChecked] = useState(false)
  const { ref_number } = useParams<{ ref_number?: string }>()
  const [refNumber, setdecodesValue] = useState<string>('')
  const [codeBank, setBankCode] = useState<string | undefined>()
  const location = useLocation()
  const [showOTPModal, setShowOTPModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showOTPForm, setShowOTPForm] = useState(false)
  const [countdown, setCountdown] = useState(300000)
  const [isFormValidated, setIsFormValidated] = useState(true)
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [transactionReference, setBailiffTransactionReferenceNumber] = useState('')
  const [transaction_reference, setReferenceNumberToUse] = useState('')
  const [showBankTransferChargeModal, setShowBankTransferChargeModal] = useState(false)
  const [otpValue, setOtpValue] = useState('')
  const [otpDigits, setOtpDigits] = useState<string[]>(['', '', '', '', '', ''])
  const [otpErrorMsg, setOtpErrorMsg] = useState('')
  const [isAutoVerifying, setIsAutoVerifying] = useState(false)
  const [respStatus, setRespStatus] = useState<number | string>('0')
  const [messages, setMessage] = useState('')
  const [token, setToken] = useState('')
  const [isEdit, setIsEdit] = useState(false)
  const [showDeclarationAlert, setShowDeclarationAlert] = useState(false)
  const [showWarningAlert, setShowWarningAlert] = useState(false)
  const [showCancelMessage, setShowCancelMessage] = useState(false)
  const [showSuccessAlert, setShowSuccessAlert] = useState(false)
  const [showWarningAlert2, setShowWarningAlert2] = useState(false)
  const [targetPaymentDateValue, setTargetPaymentDateValue] = useState<string | boolean>(false)
  const [showForm, setShowForm] = useState(false)
  const [paymentAmount, setPaymentAmount] = useState<string | number>('')
  const [bailiffId, setBailiffId] = useState('')
  const [refundableAmount, setRefundableAmount] = useState('0')
  const [showBankCodeModal, setShowBankCodeModal] = useState(false)
  const [showHello, setShowHello] = useState(true)
  const [fileList, setFileList] = useState<any[]>([])
  const [isVisible, setIsVisible] = useState(true)
  const [existingRefundRequest, setExistingRefundRequest] = useState<any>(null)
  const [existingStatus, setExistingStatus] = useState<string>('')
  const isFormLocked = existingRefundRequest != null
  const [isNextDisabled, setIsNextDisabled] = useState(true)
  const steps = [
    { title: 'Details Verification' },
    { title: 'Provide Payment Details' },
    { title: 'Final Step' }
  ]

  const handleAgree = (): void => {
    setShowBankTransferChargeModal(false)
    setShowForm(true)
  }

  const nextStep = (): void => {
    setCurrentStep(currentStep + 1)
  }

  const prevStep = (): void => {
    setCurrentStep(currentStep - 1)
  }

  const handleNextClick = async (): Promise<void> => {
    if (currentStep === 2) {
      try {
        await form.validateFields([
          'bailiff_assigned',
          'bailiff_national_id_number',
          'beneficiary_account_number',
          'beneficiary_bank_account_name',
          'beneficiary_bank_name',
          'bailiff_phone_number',
          'amount_refunded'
        ])
        nextStep()
      } catch (e) {
        // Scroll to first error and show a helpful message
        const err = e as { errorFields?: Array<{ name?: string | string[] }> }
        const firstError = Array.isArray(err?.errorFields) ? err.errorFields[0] : undefined
        if (firstError?.name != null) {
          try {
            form.scrollToField(firstError.name, { block: 'center' })
          } catch {}
        }
        void message.warning('Please fill in all required payment details before continuing.')
      }
    } else {
      nextStep()
    }
  }

  const handleFileChange = (info: UploadChangeParam<any>): void => {
    const selectedFile = info.fileList[0]?.originFileObj as File | undefined
    const maxAttachmentSizeBytes = 5 * 1024 * 1024
    if (selectedFile != null) {
      const isPdfFile =
        selectedFile.type === 'application/pdf' ||
        selectedFile.name.toLowerCase().endsWith('.pdf')
      if (!isPdfFile) {
        void message.error('Only PDF files are allowed.')
        setFileList([])
        return
      }
      if (selectedFile.size > maxAttachmentSizeBytes) {
        void message.error('Attachment is too large. Maximum allowed size is 5MB.')
        setFileList([])
        return
      }
    }
    setFileList(info.fileList.slice(-1))
  }

  const getFriendlyUploadErrorMessage = (error: unknown): string => {
    const errorRecord: Record<string, unknown> =
      (typeof error === 'object' && error !== null) ? (error as Record<string, unknown>) : {}
    const responseRecord: Record<string, unknown> =
      (typeof errorRecord.response === 'object' && errorRecord.response !== null)
        ? (errorRecord.response as Record<string, unknown>)
        : {}
    const responseData: Record<string, unknown> =
      (typeof responseRecord.data === 'object' && responseRecord.data !== null)
        ? (responseRecord.data as Record<string, unknown>)
        : {}
    const serverMessage: string =
      (typeof responseData.message === 'string')
        ? responseData.message
        : ''
    const rawErrorCode: string =
      (typeof responseData.error === 'string')
        ? responseData.error.toLowerCase()
        : ''
    const normalizedServerMessage = serverMessage.toLowerCase()
    const normalizedAxiosMessage =
      (typeof errorRecord.message === 'string') ? errorRecord.message.toLowerCase() : ''

    if (
      normalizedServerMessage.includes('only valid pdf files are allowed') ||
      normalizedServerMessage.includes('invalid pdf')
    ) {
      return 'Invalid file format. Please upload a valid PDF document.'
    }

    if (
      normalizedServerMessage.includes('attachment is required') ||
      normalizedServerMessage.includes('please upload a required document')
    ) {
      return 'Please attach your bank slip PDF before submitting.'
    }

    if (
      rawErrorCode.includes('limit_file_size') ||
      normalizedServerMessage.includes('file too large') ||
      normalizedAxiosMessage.includes('file too large')
    ) {
      return 'Attachment is too large. Maximum allowed size is 5MB.'
    }

    return (serverMessage !== '')
      ? serverMessage
      : 'Failed to upload attachment. Please use a valid PDF file (max 5MB).'
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setOtpValue(e.target.value)
  }

  const handleOTPFormCancel = (): void => {
    setShowOTPModal(false)
    setOtpDigits(['', '', '', '', '', ''])
    setOtpValue('')
    setOtpErrorMsg('')
    setCountdown(300000)
  }

  // OTP input handlers
  const handleOtpChange = (index: number, value: string): void => {
    if (!/^[0-9]?$/.test(value)) { return }
    const next = [...otpDigits]
    next[index] = value
    setOtpDigits(next)
    setOtpValue(next.join(''))
    const nextInput = document.getElementById(`otp-input-bailiff-${index + 1}`) as HTMLInputElement | null
    if (value !== '' && nextInput !== null) { nextInput.focus() }
  }

  const handleOtpKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === 'Backspace' && otpDigits[index] === '') {
      const prevInput = document.getElementById(`otp-input-bailiff-${index - 1}`) as HTMLInputElement | null
      if (prevInput !== null) { prevInput.focus() }
    }
  }

  const handleOtpPaste = (e: React.ClipboardEvent<HTMLInputElement>): void => {
    e.preventDefault()
    const text = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6)
    if (text.length === 0) { return }
    const filled = Array.from({ length: 6 }, (_, i) => text[i] ?? '')
    setOtpDigits(filled)
    setOtpValue(filled.join(''))
    const lastIndex = Math.min(text.length, 6) - 1
    const nextInput = document.getElementById(`otp-input-bailiff-${lastIndex}`) as HTMLInputElement | null
    if (nextInput !== null) { nextInput.focus() }
  }

  // Handle Resend OTP
  const handleResendOTP = async (): Promise<void> => {
    if (transaction_reference === '' || transaction_reference == null) {
      void message.error('Transaction reference is missing. Please refresh the page.')
      return
    }

    const payloadOTPForRefund = {
      transaction_reference: transaction_reference,
      status: 'PENDING'
    }

    // Reset OTP fields
    setOtpDigits(['', '', '', '', '', ''])
    setOtpValue('')
    setOtpErrorMsg('')

    try {
      // Show loading message
      const hideLoading = message.loading('Resending OTP to your phone...', 0)

      const respo = await InstitutionUserService.bailiffCreateOtpCode(payloadOTPForRefund)

      hideLoading()

      if (respo.status === 200 || respo.status === 201) {
        // Reset countdown to 5 minutes
        setCountdown(300000)
        void message.success({
          content: 'OTP has been resent to your phone number. Please check your SMS.',
          duration: 5
        })
        // Focus first input
        setTimeout(() => {
          const firstInput = document.getElementById('otp-input-bailiff-0') as HTMLInputElement | null
          if (firstInput !== null) {
            firstInput.focus()
          }
        }, 100)
      } else {
        void message.error('Failed to resend OTP. Please try again.')
      }
    } catch (error: any) {
      // eslint-disable-next-line no-console
      console.error('Resend OTP Error:', error)

      if (error?.response != null) {
        const status = error.response.status
        const errorData = error.response.data

        if (status === 404) {
          void message.warning('OTP may have already been sent. Please check your phone.')
          setCountdown(300000)
        } else if (status === 400) {
          const errorMessage = (errorData?.message != null) ? String(errorData.message) : 'Invalid request. Please try again.'
          void message.error(errorMessage)
        } else {
          const errorMessage = (errorData?.message != null) ? String(errorData.message) : 'Failed to resend OTP. Please try again.'
          void message.error(errorMessage)
        }
      } else if (error?.message === 'Network Error' || error?.code === 'ECONNABORTED') {
        void message.error('Network error. Please check your internet connection and try again.')
      } else {
        void message.error('Failed to resend OTP. Please try again.')
      }
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false)
    }, 3000)
    return () => {
      clearTimeout(timer)
    }
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowHello(false)
    }, 30 * 1000)
    return () => { clearTimeout(timer) }
  }, [])

  const handleOTPSubmit = async (): Promise<void> => {
    try {
      setIsAutoVerifying(true)
      setLoadingRefund(true)
      setOtpErrorMsg('')
      const joinedOtp = otpDigits.join('')
      const otp = joinedOtp !== '' ? joinedOtp : otpValue
      if (typeof otp !== 'string' || otp.length !== 6) {
        setOtpErrorMsg('Please enter a valid 6-digit OTP')
        setIsAutoVerifying(false)
        setLoadingRefund(false)
        return
      }

      const res = await InstitutionUserService.getBailiffLastInsertedData()
      const verifyData = res.data[0]
      setBailiffTransactionReferenceNumber(verifyData.transaction_reference)
      const payloadForVerifyOTP = {
        transaction_reference: verifyData.transaction_reference,
        otp
      }
      const confirmationPayload = {
        transaction_reference: verifyData.transaction_reference,
        status: 'RECEIVED REQUEST'
      }

      const respo = await InstitutionUserService.bailiffVerifyOtpToSendRequest(payloadForVerifyOTP)

      if (respo.status === 200) {
        setShowOTPModal(false)
        setOtpDigits(['', '', '', '', '', ''])
        setOtpValue('')

        const confRespo = await InstitutionUserService.BailiffRefundRequestConfirmation(confirmationPayload)

        if (confRespo.status === 200) {
          setShowSuccessAlert(true)
        } else {
          setShowCancelMessage(false)
        }
      } else {
        setOtpErrorMsg('OTP verification failed. Please try again.')
        setOtpDigits(['', '', '', '', '', ''])
        setOtpValue('')
        setIsAutoVerifying(false)
        setLoadingRefund(false)
        const firstInput = document.getElementById('otp-input-bailiff-0') as HTMLInputElement | null
        if (firstInput !== null) {
          firstInput.focus()
        }
      }
    } catch (error: any) {
      setOtpErrorMsg((error?.response?.data?.message != null) ? String(error.response.data.message) : 'Failed to verify OTP. Please try again.')
      void message.error((error?.response?.data?.message != null) ? String(error.response.data.message) : 'Failed to verify OTP. Please try again.')
      setOtpDigits(['', '', '', '', '', ''])
      setOtpValue('')
      setIsAutoVerifying(false)
      setLoadingRefund(false)
      const firstInput = document.getElementById('otp-input-bailiff-0') as HTMLInputElement | null
      if (firstInput !== null) {
        firstInput.focus()
      }
    } finally {
      setIsAutoVerifying(false)
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowHello(true)
    }, 20000)
    return () => {
      clearTimeout(timer)
    }
  }, [])

  // Auto-verify OTP when all 6 digits are entered
  useEffect(() => {
    const otpString = otpDigits.join('')
    if (otpString.length === 6 && !loadingRefund && !isAutoVerifying && showOTPModal) {
      setIsAutoVerifying(true)
      setTimeout(() => {
        void handleOTPSubmit()
      }, 100)
    }
  }, [otpDigits, loadingRefund, isAutoVerifying, showOTPModal])

  // Reset countdown and focus first input when OTP modal opens
  useEffect(() => {
    if (showOTPModal) {
      setCountdown(300000)
      setOtpDigits(['', '', '', '', '', ''])
      setOtpValue('')
      setOtpErrorMsg('')
      // Focus first input after modal is rendered
      setTimeout(() => {
        const firstInput = document.getElementById('otp-input-bailiff-0') as HTMLInputElement | null
        if (firstInput !== null) {
          firstInput.focus()
        }
      }, 100)
    }
  }, [showOTPModal])

  useEffect(() => {
    let timer: NodeJS.Timeout
    if (showOTPModal) {
      timer = setInterval(() => {
        setCountdown((prevCountdown) => {
          if (prevCountdown === 0) {
            clearInterval(timer)
            return 0
          }
          return prevCountdown - 1000
        })
      }, 1000)
    }

    return () => {
      if (timer !== undefined) {
        clearInterval(timer)
      }
    }
  }, [showOTPModal])

  useEffect((): void => {
    const fetchData = async (): Promise<void> => {
      setLoading(true)

      if (ref_number === null || ref_number === undefined || ref_number === '') {
        void message.error('Failed to load data. Reference number is missing.')
        setShowCancelMessage(true)
        setLoading(false)
        return
      }

      try {
        const decodedValue: string = decodeURIComponent(escape(atob(ref_number)))
        const trimmedValue: string = decodedValue.substring(7, decodedValue.length - 7)
        setdecodesValue(trimmedValue)

        const resp = await InstitutionUserService.loadBidsDetailsForRefund(trimmedValue)
        const data = resp?.data

        if (resp?.status === 200 && data != null) {
          const winnerResp = await InstitutionUserService.loadWinnerBidderDetailsForRefund(trimmedValue)
          const winnerData = winnerResp?.data
          if (winnerData?.payment != null) {
            form.setFieldsValue({
              amount: parseInt(String(winnerData.payment.amount ?? 0), 10).toLocaleString(),
              transaction_currency: winnerData.payment.currency ?? '',
              execution_case_number: winnerData.bid?.auction?.execution_case_no,
              bidder_national_id_number: winnerData.bid?.bidder?.nid ?? '',
              bidder_id: winnerData.bid?.bidder?.bidder_id ?? '',
              property_id: winnerData.bid?.auction?.property_id ?? '',
              fullName: winnerData.bid?.bidder?.full_name ?? '',
              transaction_reference: winnerData.ref_number ?? '',
              bidder_phone_number: winnerData.bid?.bidder?.phone_number ?? '',
              bid_security_id: winnerData.payment.bid_security_id ?? '',
              bid_payment_date: winnerData.payment.payment_date ?? ''
            })

            setPaymentDate(winnerData.payment.payment_date ?? '')
            setPaymentAmount(winnerData.payment.amount ?? 0)
            setReferenceNumberToUse(winnerData.ref_number ?? '')
          }
        } else {
          // eslint-disable-next-line no-console
          console.error('Failed to fetch data. Server returned status')
          setShowCancelMessage(true)
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to load data. Contact support.')
        setShowCancelMessage(true)
      } finally {
        setLoading(false)
      }
    }

    void fetchData()
  }, [ref_number, form, location.search, codeBank])

  useEffect(() => {
    const checkBailiffRequest = async (): Promise<void> => {
      try {
        // eslint-disable-next-line @typescript-eslint/promise-function-async
        const statusesToCheck = [
          'RECEIVED REQUEST',
          'Downloaded to be Refunded',
          'REFUNDED',
          'REJECTED',
          'CANCELLED',
          'PROCESSING'
        ]
        const checks = await Promise.allSettled(
          // eslint-disable-next-line @typescript-eslint/promise-function-async
          statusesToCheck.map((status) =>
            InstitutionUserService.loadBailiffRefundRequestId({
              transaction_reference: refNumber,
              status
            })
          )
        )

        const successfulMatch = checks.find(
          (r: any) => r.status === 'fulfilled' && r.value?.status === 200 && r.value?.data != null
        ) as any

        if (successfulMatch != null) {
          setExistingRefundRequest(successfulMatch.value.data)
          setExistingStatus(successfulMatch.value.data?.status ?? '')
          setShowWarningAlert(true)
          setIsNextDisabled(true)
        } else {
          setShowWarningAlert(false)
          setIsNextDisabled(false)
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Error checking bailiff request', err)
      }
    }

    if (refNumber != null) {
      void checkBailiffRequest()
    }
  }, [refNumber])

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleBankChange = (value: string) => {
    const rawAmount = Number(paymentAmount)
    const amount = !isNaN(rawAmount) ? rawAmount : 0

    // Map of bank names to their codes
    const bankCodes: Record<string, string> = {
      'Bank of Kigali Plc': '40',
      'Equity Bank Rwanda Plc': '85',
      'BPR Bank Rwanda': '44',
      'Ecobank Rwanda Plc': '11',
      'Guaranty Trust Bank Rwanda Plc': '70',
      'Access Bank Rwanda Plc': '15',
      'Zigama Css': '75',
      'URWEGO OPPORTUNITY BANK PLC': '45',
      'Bank of Africa Rwanda Plc': '76',
      'UNGUKA BANK': '80',
      'AB BANK': '20',
      'I&M Bank Rwanda Plc': '10',
      'Letshego Rwanda Plc': '21',
      'COPEDU Plc': '27',
      'Vision Fund Plc': '28',
      'Compagnie Generale de Banque': '55',
      'National Bank of Rwanda': '00',
      'Development Bank of Rwanda Plc': '50',
      'RIM Ltd': '32',
      'Atlantique Microfinance Plc': '22',
      'Umutanguha Finance Company Plc': '23',
      'Duterimberere-IMF Plc': '24',
      'Goshen Finance Plc': '26',
      'Financial Safety Co Plc': '29',
      'MUGANGA SACCO': '33',
      'Inkunga Finance Plc': '31',
      'UMWALIMU SACCO': '90',
      'Commercial Bank of Africa Rwanda PLC': '25' // NCBA Bank Rwanda PLC
    }

    // Banks that should have 1000 deducted
    const deduct1000Banks = [
      'Equity Bank Rwanda Plc',
      'BPR Bank Rwanda',
      'Ecobank Rwanda Plc',
      'Guaranty Trust Bank Rwanda Plc',
      'Access Bank Rwanda Plc',
      'Zigama Css',
      'URWEGO OPPORTUNITY BANK PLC',
      'Bank of Africa Rwanda Plc',
      'UNGUKA BANK',
      'AB BANK',
      'I&M Bank Rwanda Plc',
      'Letshego Rwanda Plc',
      'COPEDU Plc',
      'Vision Fund Plc',
      'Compagnie Generale de Banque',
      'National Bank of Rwanda',
      'Development Bank of Rwanda Plc',
      'RIM Ltd',
      'Atlantique Microfinance Plc',
      'Umutanguha Finance Company Plc',
      'Duterimberere-IMF Plc',
      'Goshen Finance Plc',
      'Financial Safety Co Plc',
      'MUGANGA SACCO',
      'Inkunga Finance Plc',
      'UMWALIMU SACCO',
      'Commercial Bank of Africa Rwanda PLC'
    ]

    const bankCode = bankCodes[value] !== undefined ? bankCodes[value] : ''
    const refundedAmount = deduct1000Banks.includes(value) ? amount - 1000 : amount

    form.setFieldsValue({
      bank_code: bankCode,
      amount_refunded: refundedAmount
    })
  }
  const onFinishLink = async (values: Record<string, unknown>): Promise<void> => {
    if (!declarationChecked) {
      setLoadingRefund(false)
      setShowDeclarationAlert(true)
      return
    }

    try {
      // Validate form
      await form.validateFields()
      setIsFormValidated(true)

      // Prepare FormData
      const formData = new FormData()
      const amount = String(form.getFieldValue('amount') ?? '').replace(/,/g, '')
      const file = fileList[0]?.originFileObj ?? null

      if (file === undefined || file === null) {
        setLoadingRefund(false)
        await message.error('Please upload a required document.')
        return
      }

      formData.append('bailiff_assignee', String(form.getFieldValue('bailiff_assigned') ?? ''))
      formData.append('bailiff_national_id', String(form.getFieldValue('bailiff_national_id_number') ?? ''))
      formData.append('bailiff_phone_number', String(form.getFieldValue('bailiff_phone_number') ?? ''))
      formData.append('property_id', String(form.getFieldValue('property_id') ?? ''))
      formData.append('execution_case_number', String(form.getFieldValue('execution_case_number') ?? ''))
      formData.append('bank_code', String(form.getFieldValue('bank_code') ?? ''))

      // Decode transaction reference safely
      const decodedRef: string =
        ref_number !== null && ref_number !== undefined && ref_number.trim() !== ''
          ? decodeURIComponent(escape(atob(ref_number)))
          : ''
      // eslint-disable-next-line max-len
      const transactionRef: string = decodedRef.length > 14 ? decodedRef.substring(7, decodedRef.length - 7) : ''

      if (transactionRef === '' || transactionRef === null || transactionRef === undefined) {
        await message.error('Transaction reference is missing. Cannot submit.')
        setLoadingRefund(false)
        return
      }

      // Append remaining FormData
      formData.append('transaction_reference', transactionRef)
      formData.append('debit_account_number', '000400696575429')
      formData.append('debit_account_name', 'MINIJUST AUCTION FUNDS MAF')
      formData.append('beneficiary_name', String(form.getFieldValue('bailiff_assigned') ?? ''))
      formData.append('beneficiary_account_name', String(form.getFieldValue('beneficiary_bank_account_name') ?? ''))
      formData.append('beneficiary_bank_name', String(form.getFieldValue('beneficiary_bank_name') ?? ''))
      formData.append('beneficiary_account_number', String(form.getFieldValue('beneficiary_account_number') ?? ''))
      formData.append('amount', String(form.getFieldValue('amount_refunded') ?? '0'))
      formData.append('transaction_currency', String(form.getFieldValue('transaction_currency') ?? ''))
      const bailiffAssignee = String(form.getFieldValue('bailiff_assigned') ?? '').trim()
      const bailiffNid = String(form.getFieldValue('bailiff_national_id_number') ?? '').trim()
      const beneficiaryName = String(form.getFieldValue('beneficiary_bank_account_name') ?? '').trim()
      formData.append(
        'reason',
        `Refund requested by ${bailiffAssignee !== '' ? bailiffAssignee : 'Bailiff'}${bailiffNid !== '' ? ` (NID ${bailiffNid})` : ''}. ` +
        `Refund of ${amount} RWF for ${beneficiaryName}. ` +
        `Phone ${String(form.getFieldValue('bailiff_phone_number') ?? '')}. ` +
        `Case ${String(form.getFieldValue('execution_case_number') ?? '')}, ` +
        `property ${String(form.getFieldValue('property_id') ?? '')}.`
      )
      formData.append('status', 'PENDING')
      formData.append('bidder_id', String(form.getFieldValue('bidder_id') ?? ''))
      formData.append('bid_security_id', String(form.getFieldValue('bid_security_id') ?? ''))
      formData.append('bidder_phone_number', String(form.getFieldValue('bidder_phone_number') ?? ''))

      // Update refund request
      const response = await InstitutionUserService.updateBailiffRefundRequest(formData)

      if (response.status === 200) {
        // Create audit log
        const generatedUuid = uuidv4()
        const auditPayload = {
          AuditLogsData: {
            action: 'UPDATE',
            table_name: 'bailiff_refund_request',
            record_id: generatedUuid,
            old_data: Object.fromEntries(formData.entries()),
            new_data: {},
            created_by: fullName,
            refund_request_id: response.data?.id ?? null
          }
        }

        try {
          await InstitutionUserService.TrackRecords(auditPayload)
        } catch (auditErr) {
          // void message.error('Audit log creation failed:')
        }

        // Delay loader update safely
        setTimeout(() => {
          setLoadingRefund(true)
        }, 5000)

        // Generate OTP
        try {
          // Validate transaction reference exists
          if (transactionRef === '' || transactionRef == null) {
            await message.error('Transaction reference is required. Please refresh the page and try again.')
            setLoadingRefund(false)
            return
          }

          const payloadOTPForRefund = {
            transaction_reference: transactionRef,
            status: 'PENDING'
          }

          // eslint-disable-next-line no-console
          console.log('Creating OTP with payload:', payloadOTPForRefund)

          // Show loading message
          const hideLoading = message.loading('Generating OTP and sending to your phone...', 0)

          const otpResponse = await InstitutionUserService.bailiffCreateOtpCode(payloadOTPForRefund)

          hideLoading()

          // eslint-disable-next-line no-console
          console.log('OTP Response:', otpResponse)

          // Check for successful OTP creation
          if (otpResponse.status === 200 || otpResponse.status === 201) {
            // OTP created successfully, show the OTP form
            setShowOTPModal(true)
            setCountdown(300000) // Reset countdown to 5 minutes (300000ms = 5 minutes)
            setOtpDigits(['', '', '', '', '', '']) // Reset OTP input fields
            setOtpValue('')
            setOtpErrorMsg('')
            void message.success({
              content: 'OTP has been sent to your phone number. Please check your SMS.',
              duration: 5
            })
            // Focus first OTP input after modal is rendered
            setTimeout(() => {
              const firstInput = document.getElementById('otp-input-bailiff-0') as HTMLInputElement | null
              if (firstInput !== null) {
                firstInput.focus()
              }
            }, 100)
          } else {
            setLoadingRefund(false)
            const responseMessage = otpResponse?.data?.message ?? 'Failed to create OTP. Please try again.'
            void message.error(responseMessage)
          }
        } catch (error: any) {
          setLoadingRefund(false)
          // eslint-disable-next-line no-console
          console.error('OTP Creation Error:', error)

          // Handle different error scenarios
          if (error?.response != null) {
            const status = error.response.status
            const errorData = error.response.data

            if (status === 404) {
              // OTP record might already exist - check if we should show the form
              void message.warning({
                content: 'OTP may have already been sent. Please check your phone for the OTP code.',
                duration: 5
              })
              // Show OTP form in case OTP was already sent
              setShowOTPModal(true)
              setCountdown(300000)
              setOtpDigits(['', '', '', '', '', ''])
              setOtpValue('')
              setOtpErrorMsg('')
            } else if (status === 400) {
              const errorMessage = (errorData?.message != null) ? String(errorData.message) : 'Invalid request. Please verify your transaction reference and try again.'
              void message.error(errorMessage)
            } else if (status === 500) {
              void message.error('Server error occurred while generating OTP. Please try again later.')
            } else if (status === 503) {
              void message.error('Service temporarily unavailable. Please try again in a few moments.')
            } else {
              const errorMessage = (errorData?.message != null) ? String(errorData.message) : 'Failed to create OTP. Please try again.'
              void message.error(errorMessage)
            }
          } else if (error?.message === 'Network Error' || error?.code === 'ECONNABORTED') {
            void message.error('Network error. Please check your internet connection and try again.')
          } else {
            void message.error('An unexpected error occurred. Please try again or contact support.')
          }
        }

        form.resetFields()
      } else if (response.status === 404) {
        await message.info('Invalid Request')
      } else {
        await message.error('Failed to submit refund request.')
      }
    } catch (err: unknown) {
      setLoadingRefund(false)
      const error = err as { response?: { status?: number } }

      if (error.response?.status === 400) {
        void message.error(getFriendlyUploadErrorMessage(error))
        setShowWarningAlert(true)
        setShowOTPModal(false)
      } else if (error.response?.status === 413) {
        void message.error('Attachment is too large. Maximum allowed size is 5MB.')
      } else if (error.response?.status === 404) {
        await message.info(
          'No records found for the provided Transaction Reference. Please verify the reference number and try again.'
        )
      } else {
        void message.error('Submission error:')
      }
    } finally {
      setLoadingRefund(false)
    }
  }

  return (
    <div className="w-full">
      <div className="navbar pay-bot-border navbar-background">
        <div className="flex">
          <div className="nav-logo">
            <img src={minijust_logo} alt="Logo" />
          </div>
          <div className="nav-content text-standard md:text-title">
            <div className="nav-content-header">MINIJUST - IECMS</div>
            <div>Bid Security Online Payment and Refund</div>
          </div>
        </div>
      </div>

      <div className="scrollableContent">
        {isFormLocked && (
          <div className="mb-4">
            <Alert
              message="This request already exists"
              description={`Form is read-only. Current status: ${existingStatus !== '' ? existingStatus : 'N/A'}.`}
              type="warning"
              showIcon
            />
          </div>
        )}

        <Form
          name="normal_login"
          layout="vertical"
          className="login-form p-8 bg-gray-50 rounded-xl shadow-lg"
          autoComplete="off"
          /* eslint-disable-next-line @typescript-eslint/no-misused-promises */
          onFinish={onFinishLink}
          form={form}
          disabled={isFormLocked}
        >
          <Space direction="vertical" size={6} className="w-full">
            <Card className="card-border rounded-xl shadow-md p-6" style={{ marginTop: 40 }}>
              {/* Form Title */}
              <h2 className="text-title font-extrabold text-center text-gray-700 mb-4">
                Request Refund
              </h2>

              {/* Progress Bar */}
              <Progress
                percent={Number(((currentStep / steps.length) * 100).toFixed(0))}
                strokeColor={{ '0%': '#52c41a', '100%': '#1890ff' }}
                showInfo={false}
                className="mb-4"
              />

              {/* Step Name */}
              <h3 className="text-center font-semibold text-large mb-6">
                Step {currentStep}: {steps[currentStep - 1].title}
              </h3>

              {/* Step 1: Verification Details */}
              {currentStep === 1 && (
                <>
                  <div className="text-green-600 font-bold text-large text-center mb-6">
                    Details Verification - Bailiff & Bidder Information
                  </div>

                  <Row gutter={[16, 16]}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Execution Case Number"
                        name="execution_case_number"
                        rules={[{ required: true, message: 'Please enter execution case number' }]}
                      >
                        <Input placeholder="Enter Execution Case Number" readOnly className="rounded-md" />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Bid Security Paid"
                        name="amount"
                        rules={[{ required: true, message: 'Please enter Amount' }]}
                      >
                        <Input placeholder="Amount" readOnly className="rounded-md" />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Currency"
                        name="transaction_currency"
                        rules={[{ required: true, message: 'Please provide the transaction currency' }]}
                      >
                        <Input placeholder="RWF" readOnly className="rounded-md" />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Bid Reference Number"
                        name="transaction_reference"
                        rules={[{ required: true, message: 'Please enter Bid Reference Number' }]}
                      >
                        <Input placeholder="Enter Bid Reference Number" readOnly className="rounded-md" />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>

                  <Col xs={24} md={12}>
                    <Form.Item
                      label="Bid Security Payment Date"
                      name="bid_payment_date"
                      rules={[{ required: true, message: 'Payment Date is required' }]}
                    >
                      <Input placeholder="PropertyID" readOnly className="rounded-md bg-gray-100" />
                    </Form.Item>
                  </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Property ID"
                        name="property_id"
                        rules={[{ required: true, message: 'Property ID is required' }]}
                      >
                        <Input placeholder="Property ID" readOnly className="rounded-md bg-gray-100" />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>

                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Bidder Names"
                        name="fullName"
                        rules={[{ required: true, message: 'Bidders Fullname is required' }]}
                      >
                        <Input placeholder="Bidders fullnames" readOnly className="rounded-md bg-gray-100" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Bidder Phone Number"
                        name="bidder_phone_number"
                        rules={[{ required: true, message: 'Bidder Phone Number is required' }]}
                      >
                        <Input placeholder="Bidders Phone number" readOnly className="rounded-md bg-gray-100" />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>

                    <Col xs={24} md={12}>
                      <Form.Item
                        // label="BidderId"
                        name="bidder_id"
                        rules={[{ required: true, message: 'Bidder Id is required' }]}
                      >
                        <Input placeholder="Bidder Id" type="hidden" readOnly className="rounded-md bg-gray-100" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        // label="Bid Security ID"
                        name="bid_security_id"
                        rules={[{ required: true, message: 'Bid Security ID is required' }]}
                      >
                        <Input placeholder="Bid Security ID" type="hidden" readOnly className="rounded-md bg-gray-100" />
                      </Form.Item>
                    </Col>
                  </Row>
                  {/* More fields similar to above with rounded inputs and consistent spacing */}
                </>
              )}

              {/* Step 2: Payment Details */}
              {currentStep === 2 && (
                <>
                  <div className="text-green-600 font-bold text-large text-center mb-6">
                    Provide Payment Details
                  </div>
                  <Row gutter={[16, 16]}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Bailiff Assigned"
                        name="bailiff_assigned"
                        rules={[{ required: true, message: 'Please enter Bailiff Assigned' }]}
                        validateTrigger={['onChange', 'onBlur']}
                      >
                        <Input
                          placeholder="Enter Bailiff Assignee"
                          className="rounded-md"
                          maxLength={100}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Bailiff's National ID Number"
                        name="bailiff_national_id_number"
                        rules={[
                          { required: true, message: "Please enter Bailiff's National ID Number" },
                          {
                            pattern: /^\d{16}$/,
                            message: 'National ID Number must be exactly 16 digits'
                          }
                        ]}
                        validateTrigger={['onChange', 'onBlur']}
                      >
                        <Input
                          placeholder="Enter Bailiff's National ID Number"
                          className="rounded-md"
                          inputMode="numeric"
                          maxLength={16}
                          onChange={(e) => {
                            const onlyDigits = e.target.value.replace(/\D/g, '').slice(0, 16)
                            form.setFieldsValue({ bailiff_national_id_number: onlyDigits })
                          }}
                          value={form.getFieldValue('bailiff_national_id_number')}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  {/* Bank Details */}
                  <Row gutter={[16, 16]}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Bank Account Number"
                        name="beneficiary_account_number"
                        rules={[
                          { required: true, message: 'Please enter Bank Account Number' },
                          { pattern: /^[0-9]+$/, message: 'Only numbers allowed' }
                        ]}
                        validateTrigger={['onChange', 'onBlur']}
                      >
                        <Input
                          placeholder="Enter Bank Account Number"
                          className="rounded-md"
                          inputMode="numeric"
                          maxLength={34}
                          onChange={(e) => {
                            const onlyDigits = e.target.value.replace(/\D/g, '')
                            form.setFieldsValue({ beneficiary_account_number: onlyDigits })
                          }}
                          value={form.getFieldValue('beneficiary_account_number')}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Bank Account Name"
                        name="beneficiary_bank_account_name"
                        rules={[{ required: true, message: 'Please enter Bank Account Name' }]}
                        validateTrigger={['onChange', 'onBlur']}
                      >
                        <Input
                          placeholder="Enter Bank Account Name"
                          className="rounded-md"
                          maxLength={100}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Bank Name"
                        name="beneficiary_bank_name"
                        rules={[{ required: true, message: 'Please enter Bank Name' }]}
                        validateTrigger={['onChange', 'onBlur']}
                      >
                        <Select placeholder="Select Beneficiary Bank" allowClear onChange={handleBankChange}>
                        <Option value="Bank of Kigali Plc">Bank of Kigali Plc</Option>
                        <Option value="Equity Bank Rwanda Plc">Equity Bank Rwanda Plc</Option>
                        <Option value="BPR Bank Rwanda">BPR Bank Rwanda</Option>
                        <Option value="Ecobank Rwanda Plc">Ecobank Rwanda Plc</Option>
                        <Option value="Guaranty Trust Bank Rwanda Plc">Guaranty Trust Bank Rwanda Plc</Option>
                        <Option value="Access Bank Rwanda Plc">Access Bank Rwanda Plc</Option>
                        <Option value="Zigama Css">Zigama Css</Option>
                        <Option value="URWEGO OPPORTUNITY BANK PLC">URWEGO OPPORTUNITY BANK PLC</Option>
                        <Option value="Bank of Africa Rwanda Plc">Bank of Africa Rwanda Plc</Option>
                        <Option value="UNGUKA BANK">UNGUKA BANK</Option>
                        <Option value="AB BANK">AB BANK</Option>
                        <Option value="I&M Bank Rwanda Plc">I&M Bank Rwanda Plc</Option>
                        <Option value="Letshego Rwanda Plc">Letshego Rwanda Plc</Option>
                        <Option value="COPEDU Plc">COPEDU Plc</Option>
                        <Option value="Vision Fund Plc">Vision Fund Plc</Option>
                        <Option value="Compagnie Generale de Banque">Compagnie Generale de Banque</Option>
                        <Option value="National Bank of Rwanda">National Bank of Rwanda</Option>
                        <Option value="Development Bank of Rwanda Plc">Development Bank of Rwanda Plc</Option>
                        <Option value="RIM Ltd">RIM Ltd</Option>
                        <Option value="Atlantique Microfinance Plc">Atlantique Microfinance Plc</Option>
                        <Option value="Umutanguha Finance Company Plc">Umutanguha Finance Company Plc</Option>
                        <Option value="Duterimberere-IMF Plc">Duterimberere-IMF Plc</Option>
                        <Option value="Goshen Finance Plc">Goshen Finance Plc</Option>
                        <Option value="Financial Safety Co Plc">Financial Safety Co Plc</Option>
                        <Option value="MUGANGA SACCO">MUGANGA SACCO</Option>
                        <Option value="Inkunga Finance Plc">Inkunga Finance Plc</Option>
                        <Option value="UMWALIMU SACCO">UMWALIMU SACCO</Option>
                        <Option value="Commercial Bank of Africa Rwanda PLC">NCBA Bank Rwanda PLC</Option>
                      </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Amount to be Refunded"
                        name="amount_refunded"
                        rules={[{ required: true, message: ' Amount Refunded is Required' }]}
                        validateTrigger={['onChange', 'onBlur']}
                      >
                        <InputNumber
                          className="rounded-md w-full"
                          placeholder="Auto-calculated based on bank"
                          min={0}
                          formatter={(value) => String(value ?? '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                          parser={(value) => (typeof value === 'string' ? value.replace(/\$\s?|(,*)/g, '') : '')}
                          value={form.getFieldValue('amount_refunded')}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        // label="Bank Code"
                        name="bank_code"
                        rules={[{ required: true, message: 'Please enter Bank Code' }]}
                      >
                        <Input placeholder="Enter Bank Code" readOnly type="hidden" className="rounded-md" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Bailiff Phone Number"
                        name="bailiff_phone_number"
                        rules={[
                          { required: true, message: 'Bailiff Phone Number is required' },
                          {
                            pattern: /^\d{10}$/,
                            message: 'Phone number must be exactly 10 digits'
                          }
                        ]}
                        validateTrigger={['onChange', 'onBlur']}
                      >
                        <Input
                          placeholder="Enter Bailiff Phone Number"
                          className="rounded-md"
                          inputMode="numeric"
                          maxLength={10}
                          onChange={(e) => {
                            const onlyDigits = e.target.value.replace(/\D/g, '').slice(0, 10)
                            form.setFieldsValue({ bailiff_phone_number: onlyDigits })
                          }}
                          value={form.getFieldValue('bailiff_phone_number')}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              )}

              {/* Step 3: Attachments */}
              {currentStep === 3 && (
                <>
                  <div className="text-green-600 font-bold text-large text-center mb-6">Attachments</div>

                  <Row justify="center" gutter={[16, 16]}>
                    <Col xs={24} md={16}>
                      <Form.Item
                        label="Upload a PDF bank slip confirming that 95% was paid to the bailiff account."
                        name="attachment"
                        rules={[{ required: true, message: 'Please attach a PDF slip' }]}
                        valuePropName="fileList"
                        getValueFromEvent={(e) => e?.fileList}
                      >
                        <Upload
                          accept=".pdf"
                          beforeUpload={() => false}
                          onChange={handleFileChange}
                          fileList={fileList}
                          maxCount={1}
                        >
                          <Button icon={<UploadOutlined />} className="rounded-md">
                            Upload PDF
                          </Button>
                        </Upload>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row justify="center">
                    <Col xs={24} md={16}>
                      <Form.Item name="declaration">
                        <Checkbox
                          onChange={(e) => { setDeclarationChecked(e.target.checked) }}
                          className="text-gray-700"
                        >
                          I, <b>{form.getFieldValue('bailiff_assigned')}</b>, hereby declare that the
                          provided information about <b>Account Number, Bank Account Name and Bank Name</b>{' '}
                          is true and accurate.
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              )}

              {/* Navigation Buttons */}
              <Row gutter={[16, 16]} justify="center" className="mt-6">
                <Col>
                  {currentStep > 1 && (
                    <Button onClick={prevStep} className="rounded-md">
                      Previous
                    </Button>
                  )}
                </Col>
                <Col>
                  {currentStep < 3 && (
                    <Button type="primary" onClick={() => { void handleNextClick() }} className="rounded-md" disabled={isNextDisabled}>
                      Next
                    </Button>
                  )}
                  {currentStep === 3 && (
                    <Button type="primary" htmlType="submit" className="rounded-md">
                      {isEdit ? 'Update' : 'Submit'}
                    </Button>
                  )}
                </Col>
              </Row>
            </Card>
          </Space>
        </Form>

        {/* Step 3: Render OTP form conditionally */}
        <Modal
          title={
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{
                width: 40,
                height: 40,
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #e0f2fe 0%, #f0f9ff 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: 'inset 0 0 0 1px #dbeafe'
              }}>
                <KeyOutlined style={{ color: '#1d4ed8', fontSize: 20 }} />
              </div>
              <span>Enter Verification Code</span>
            </div>
          }
          visible={showOTPModal}
          onCancel={handleOTPFormCancel}
          footer={[
            <Button key="cancel" onClick={handleOTPFormCancel}>Cancel</Button>,
            <Button
              key="submit"
              type="primary"
              loading={loadingRefund || isAutoVerifying}
              disabled={otpDigits.join('').length !== 6 || loadingRefund || isAutoVerifying}
              onClick={() => {
                void handleOTPSubmit()
              }}
            >
              {isAutoVerifying ? 'Verifying...' : 'Verify'}
            </Button>
          ]}
          className="custom-modal"
          keyboard={false}
          maskClosable={false}
          width={500}
          centered
        >
          <div style={{ padding: '8px 0' }}>
            <div style={{ textAlign: 'center', marginBottom: '24px' }}>
              <p style={{ margin: '0 0 8px 0', color: '#666', fontSize: '14px' }}>
                We sent a verification code to your phone number ending with{' '}
                <strong style={{ color: '#1890ff' }}>
                  {phone_number.length > 2 ? `****${phone_number.slice(-2)}` : '******'}
                </strong>
                {bailiffEmail !== '' && (
                  <span> or check your email: <strong style={{ color: '#1890ff' }}>{bailiffEmail}</strong></span>
                )}
              </p>
              <p style={{ margin: '0', color: '#999', fontSize: '12px' }}>
                Please enter the 6-digit code below
              </p>
            </div>

            {(otpErrorMsg !== '') && (
              <Alert
                message={otpErrorMsg}
                type="error"
                showIcon
                style={{ marginBottom: '20px' }}
                closable
                onClose={() => { setOtpErrorMsg('') }}
              />
            )}

            <Form.Item
              name="otp"
              rules={[{ required: otpDigits.join('').length !== 6, message: 'Please input your 6-digit OTP' }]}
              style={{ marginBottom: '20px' }}
            >
              <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', marginBottom: '8px' }}>
                {otpDigits.map((digit, idx) => (
                  <Input
                    key={idx}
                    id={`otp-input-bailiff-${idx}`}
                    value={digit}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={1}
                    onChange={(e) => { handleOtpChange(idx, e.target.value) }}
                    onKeyDown={(e) => { handleOtpKeyDown(idx, e) }}
                    onPaste={(e) => { handleOtpPaste(e) }}
                    style={{
                      width: '48px',
                      height: '56px',
                      textAlign: 'center',
                      fontSize: '24px',
                      fontWeight: '600',
                      borderRadius: '8px',
                      borderColor: (otpErrorMsg !== '') ? '#ff4d4f' : '#d9d9d9',
                      borderWidth: '2px',
                      transition: 'all 0.2s'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#1890ff'
                      e.target.style.boxShadow = '0 0 0 2px rgba(24, 144, 255, 0.2)'
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = (otpErrorMsg !== '') ? '#ff4d4f' : '#d9d9d9'
                      e.target.style.boxShadow = 'none'
                    }}
                  />
                ))}
              </div>
            </Form.Item>

            <div style={{ textAlign: 'center', marginTop: '24px' }}>
              <p style={{ margin: '0 0 12px 0', color: '#666', fontSize: '13px' }}>
                Code expires in{' '}
                <code
                  style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: countdown < 60000 ? '#ff4d4f' : '#1890ff',
                    background: '#f0f0f0',
                    padding: '4px 8px',
                    borderRadius: '4px'
                  }}
                >
                  {moment(countdown).format('mm:ss')}
                </code>
              </p>
              <div style={{ marginTop: '16px' }}>
                {countdown === 0
                  ? (
                      <Button
                        type="link"
                        onClick={() => {
                          void handleResendOTP()
                        }}
                        style={{ padding: '0', fontWeight: '600' }}
                      >
                        Resend Code
                      </Button>
                    )
                  : (
                      <p style={{ margin: '0', color: '#999', fontSize: '12px' }}>
                        Didn&apos;t receive the code?{' '}
                        <Button
                          type="link"
                          disabled
                          style={{ padding: '0', fontSize: '12px' }}
                        >
                          Resend in {moment(countdown).format('mm:ss')}
                        </Button>
                      </p>
                    )}
              </div>
            </div>

            <div
              style={{
                marginTop: '20px',
                padding: '12px',
                background: '#f0f9ff',
                borderRadius: '8px',
                border: '1px solid #bae7ff'
              }}
            >
              <p style={{ margin: '0', fontSize: '12px', color: '#666', lineHeight: '1.5' }}>
                <strong>💡 Tip:</strong> You can paste the entire 6-digit code at once, or enter each digit
                individually.
              </p>
            </div>
          </div>
        </Modal>
        {showDeclarationAlert && (
          <Modal
            visible={showDeclarationAlert}
            onCancel={() => {
              setShowDeclarationAlert(false)
            }}
            footer={null}
            centered
          >
            <Alert
              message="Warning"
              description="Please accept the declaration before submitting."
              type="warning"
              showIcon
              style={{
                width: '100%'
              }} // Set alert background color
              onClose={() => {
                setShowDeclarationAlert(false)
              }}
            />
          </Modal>
        )}
        {showWarningAlert && (
          <Modal
            visible={showWarningAlert}
            onCancel={() => {
              setShowWarningAlert(false)
            }}
            footer={null}
            centered
          >
            <div style={{ width: '100%' }}>
              <Alert
                message="Existing Refund Request Found"
                description={`A refund request already exists for this reference. Current status: ${existingStatus !== '' ? existingStatus : 'N/A'}.`}
                type="info"
                showIcon
              />
              <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  type="primary"
                  onClick={() => {
                    setShowWarningAlert(false)
                    navigate('/view-bailiff-refund-request', { state: existingRefundRequest })
                  }}
                >
                  View details
                </Button>
              </div>
            </div>
          </Modal>
        )}
        {showSuccessAlert && (
          <Modal
            visible={showSuccessAlert}
            onCancel={() => {
              setShowSuccessAlert(false)
            }}
            footer={null}
            centered
          >
            <Alert
              message="Informational Notes"
              /* eslint-disable-next-line @typescript-eslint/restrict-template-expressions */
              description="Refund Request Submitted. Waiting to be Refunded..."
              type="info"
              showIcon
              style={{
                width: '100%'
              }} // Set alert background color
              onClose={() => {
                setShowSuccessAlert(false)
              }}
            />
          </Modal>
        )}
        {showCancelMessage && (
          <div className="cancel-message">
            <div className="separator"></div>
            <p>
              <h3>Thank you for using our services.</h3>
            </p>
            <div className="separator"></div>
            <p>
              For any other support, please contact us on
              <span>
                <strong>iecms-support@minijust.gov.rw</strong>
              </span>
              .
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default BaillifRequestingBidSecurityFees
